import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Package, Calculator, FileText, Users, BarChart3, 
  Sparkles, ArrowRight, CheckCircle, AlertCircle
} from 'lucide-react';

const OfferTestPage = () => {
  const navigate = useNavigate();
  
  const modules = [
    {
      title: 'Dashboard',
      status: 'working',
      path: '/dashboard',
      icon: BarChart3,
      description: '✅ Działa poprawnie'
    },
    {
      title: 'Kalkulator Standard',
      status: 'working',
      path: '/calculator',
      icon: Calculator,
      description: '✅ Naprawiony - ceny zaktualizowane'
    },
    {
      title: 'Kalkulator Crystal PRO',
      status: 'working',
      path: '/calculator-pro',
      icon: Sparkles,
      description: '✅ Naprawiony - 8 produktów'
    },
    {
      title: 'Generator Ofert',
      status: 'testing',
      path: '/offer/new',
      icon: FileText,
      description: '🔧 W trakcie testowania'
    },
    {
      title: 'Lista Ofert',
      status: 'testing',
      path: '/offers',
      icon: Package,
      description: '🔧 Testowanie HomePage'
    },
    {
      title: 'Klienci',
      status: 'unknown',
      path: '/clients',
      icon: Users,
      description: '❓ Do sprawdzenia'
    }
  ];

  const getStatusColor = (status: string) => {
    switch(status) {
      case 'working': return 'border-green-500 bg-green-500/10';
      case 'testing': return 'border-yellow-500 bg-yellow-500/10';
      case 'error': return 'border-red-500 bg-red-500/10';
      default: return 'border-gray-500 bg-gray-500/10';
    }
  };

  const getStatusIcon = (status: string) => {
    switch(status) {
      case 'working': return <CheckCircle className="w-5 h-5 text-green-500" />;
      case 'testing': return <AlertCircle className="w-5 h-5 text-yellow-500" />;
      case 'error': return <AlertCircle className="w-5 h-5 text-red-500" />;
      default: return <AlertCircle className="w-5 h-5 text-gray-500" />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900/20 to-gray-900 p-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">
            PlexiSystem v4.0 - Panel Testowy
          </h1>
          <p className="text-gray-400">
            Status modułów systemu - Kliknij aby przetestować
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {modules.map((module) => (
            <button
              key={module.path}
              onClick={() => navigate(module.path)}
              className={`p-6 rounded-xl border-2 ${getStatusColor(module.status)} hover:scale-105 transition-all cursor-pointer`}
            >
              <div className="flex items-start justify-between mb-4">
                <module.icon className="w-8 h-8 text-white" />
                {getStatusIcon(module.status)}
              </div>
              <h3 className="text-xl font-bold text-white mb-2">
                {module.title}
              </h3>
              <p className="text-sm text-gray-400">
                {module.description}
              </p>
              <div className="mt-4 flex items-center text-purple-400">
                <span className="text-sm">Testuj moduł</span>
                <ArrowRight className="w-4 h-4 ml-1" />
              </div>
            </button>
          ))}
        </div>

        <div className="mt-8 p-6 bg-black/40 rounded-xl border border-white/10">
          <h2 className="text-xl font-bold text-white mb-4">
            Informacje o błędach
          </h2>
          <div className="space-y-2 text-sm text-gray-400">
            <p>• Błąd 404 dla tabeli 'customers' → Naprawiono (używamy 'clients')</p>
            <p>• Nieprawidłowe linki w HomePage → Naprawiono</p>
            <p>• Routing do dashboard → Naprawiono</p>
            <p>• Supabase multiple instances → Ostrzeżenie (nie wpływa na działanie)</p>
          </div>
        </div>

        <div className="mt-6 flex gap-4">
          <button
            onClick={() => navigate('/dashboard')}
            className="px-6 py-3 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-all"
          >
            Wróć do Dashboard
          </button>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 bg-gray-700 text-white rounded-xl hover:bg-gray-600 transition-all"
          >
            Odśwież stronę
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferTestPage;
